import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ModalService } from "@rubbl-core";
import { SearchRequest, SearchResultsService } from "@rubbl-search-results";
import { Subscription } from "rxjs";
import { SearchResultsFilterModalComponent } from "../search-results-filter-modal/search-results-filter-modal.component";

@Component({
  selector: "app-search-results-mobile-toggle",
  templateUrl: "./search-results-mobile-toggle.component.html",
  styleUrls: ["./search-results-mobile-toggle.component.scss"],
})
export class SearchResultsMobileToggleComponent {
  @Input() route: string;
  searchFacetsSubscription: Subscription;
  searchRequest: SearchRequest;
  facetSelectedCount: number = 0;

  constructor(private searchResultsService: SearchResultsService, private router: Router, private modalService: ModalService) {
    this.searchFacetsSubscription = this.searchResultsService.searchRequest$.subscribe(searchRequest => {
      this.searchRequest = searchRequest;
      this.facetSelectedCount = searchRequest.facetSelectedCount;
    });
  }

  ngOnDestroy() {
    this.searchFacetsSubscription?.unsubscribe();
  }

  openFilterModal() {
    const modalRef = this.modalService.fullPageModal(SearchResultsFilterModalComponent);
    modalRef.componentInstance.searchRequest = this.searchRequest;
    modalRef.result.then(
      success => {},
      (oldFacets: any) => {},
    );
  }

  swapView() {
    const url = this.searchResultsService.searchRequest.swapView();
    this.router.navigate([url], { queryParamsHandling: "merge" });
  }
}
